module.exports = __webpack_public_path__ + "media/landing_page/lp4-hero-desktop-01-1b70c8bf.webp";